import React, { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { FiHome, FiSearch, FiPlus, FiShield, FiMessageSquare } from "react-icons/fi";
import { useAuth } from "../context/AuthContext";
import { api } from "../api";
import "./MobileTabBar.css";

/**
 * Mobile-only bottom tab bar (Home · Browse · Sell · Escrow · Messages)
 * plus a floating "chat" shortcut. Both are hidden on screens > 860px.
 */
export default function MobileTabBar() {
  const { isLoggedIn, loading } = useAuth();
  const { pathname } = useLocation();
  const [unread, setUnread] = useState(0);

  const sellHref = isLoggedIn || loading ? "/dashboard/post" : "/login?next=%2Fdashboard%2Fpost";
  const escrowHref = isLoggedIn || loading ? "/dashboard/escrow" : "/login?next=%2Fdashboard%2Fescrow";
  const msgHref  = isLoggedIn || loading ? "/dashboard/messages" : "/login?next=%2Fdashboard%2Fmessages";

  useEffect(() => {
    if (!isLoggedIn) { setUnread(0); return; }
    let live = true;
    const load = () => api("/me/unread-count").then(d => live && setUnread(d.count || 0)).catch(() => {});
    load();
    const t = setInterval(load, 60_000);
    return () => { live = false; clearInterval(t); };
  }, [isLoggedIn]);

  const onMessages = pathname.startsWith("/dashboard/messages");
  const onPostAd   = pathname.startsWith("/dashboard/post");

  // Product pages have their own fixed contact bar (Call / SMS / WhatsApp / Share),
  // and the post-ad screen is a compose flow: don't stack on top of those.
  const onProduct = pathname.startsWith("/product/");
  if (onPostAd || onProduct) return null;

  const tab = ({ isActive }) => `mtb-tab${isActive ? " active" : ""}`;

  return (
    <>
      {!onMessages && (
        <Link to={msgHref} className="mtb-fab" aria-label="Open messages">
          <FiMessageSquare size={24} />
          {unread > 0 && <span className="mtb-badge mtb-badge-fab">{unread > 99 ? "99+" : unread}</span>}
        </Link>
      )}

      <nav className="mtb" aria-label="Primary">
        <NavLink to="/" end className={tab}>
          <FiHome size={24} />
          <span>Home</span>
        </NavLink>

        <NavLink to="/all" className={tab}>
          <FiSearch size={24} />
          <span>Browse</span>
        </NavLink>

        <Link to={sellHref} className="mtb-sell" aria-label="Sell">
          <span className="mtb-sell-btn"><FiPlus size={28} /></span>
          <span className="mtb-sell-label">Sell</span>
        </Link>

        <NavLink to={escrowHref} className={tab}>
          <FiShield size={24} />
          <span>Escrow</span>
        </NavLink>

        <NavLink to={msgHref} className={tab}>
          <span className="mtb-icon-wrap">
            <FiMessageSquare size={24} />
            {unread > 0 && <span className="mtb-badge">{unread > 99 ? "99+" : unread}</span>}
          </span>
          <span>Messages</span>
        </NavLink>
      </nav>
    </>
  );
}
